export default __webpack_public_path__ + "static/media/language-sk.80c1d1c3.svg";